import React from 'react';
import { useSelector } from 'react-redux';
import Satisfy from 'components/molecules/Modal/Satisfy';
import Feedback from 'components/molecules/Modal/Feedback';
import Usability from 'components/molecules/Modal/Usability';
import ConversationGuide from 'components/molecules/Modal/ConversationGuide';
import ServiceGuide from 'components/molecules/Modal/ServiceGuide';
import Response from 'components/molecules/Modal/Feedback/response';
import Organization from 'components/molecules/Modal/Organization';
import Complaint from 'components/molecules/Modal/Complaint';
import ComplaintSearch from 'components/molecules/Modal/ComplaintSearch';
import ExpandImage from 'components/molecules/Modal/ExpandImage';
import Loading from 'components/molecules/Modal/Loading';

/**
 * Chatting:Modal
 */

const ChatModal = () => {
  const isActive = useSelector(state => state.isActive);
// console.log("active : ",isActive);
  return (
    <>
      {isActive.satisfyModal ? <Satisfy /> : null}
      {isActive.feedbackModal ? <Feedback /> : null}
      {isActive.usabilityModal ? <Usability /> : null}
      {isActive.feedbackResponseModal ? <Response /> : null}
      {isActive.conversationGuideModal ? <ConversationGuide /> : null}
      {isActive.serviceGuideModal ? <ServiceGuide /> : null}
      {isActive.organizationModal ? <Organization /> : null}
      {isActive.expandImageModal ? <ExpandImage /> : null}
      {isActive.complaintModal ? <Complaint /> : null}
      {isActive.complaintSearchModal ? <ComplaintSearch /> : null}
      {isActive.loading ? <Loading /> : null}
    </>
  );
};

export default ChatModal;
